<template>
    <div class="card">
        <div class="card-body">
            <Table 
                :dataTable="table.dataTable"
                :title="table.title"
            >
                <template v-slot:header>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="btn-responsive">
                            <button type="button" class="btn btn-primary" @click="$router.push('/testimony-library/add')">
                                <i class="fa fa-plus"></i> Add
                            </button>
                        </div>
                        <div class="d-flex align-items-center" style="gap: 2rem;">
                            <div class="form-group">
                                <label for="user-name">User Name</label>
                                <input
                                    id="user-name"
                                    type="text"
                                    v-model="searchUserName"
                                    class="form-control"
                                    placeholder="Enter User Name"
                                    @input="handleSearchUserName()"
                                >
                            </div>
                            <div class="form-group" style="width: 220px;">
                                <label for="condition">Condition</label>
                                <multiselect
                                    v-model="filterCondition"
                                    label="namePage"
                                    id="condition"
                                    track-by="id" 
                                    placeholder="Select Condition"
                                    :options="conditions"
                                    :multiple="false"
                                    :searchable="true"
                                    :max-height="600"
                                    select-label=""
                                    @input="getList()"
                                >
                                    <span slot="noResult">Oops! There is no condition.</span>
                                </multiselect>
                            </div>
                            <span
                                class="text-blue text-bold-500 cursor-pointer"
                                @click="resetFilter"
                            >
                                Reset Filter
                            </span>
                        </div>
                    </div>
                </template>

                <template v-slot:thead>
                    <thead>
                        <tr>
                            <th v-for="(data, index) in table.dataTable.header" :key="index">{{ data }}</th>
                        </tr>
                    </thead>
                </template>

                <template v-slot:action="{ data }">
                    <div class="btn-action-block d-flex align-items-center">
                        <switches
                            @input="toggleVisibility(data)"
                            :emit-on-mount="false"
                            v-model="data.isVisible" 
                            :label="data.isVisible ? 'Show' : 'Hidden'"
                            :color="data.isVisible ? 'green' : 'red'"
                            class="mr-1">
                        </switches>
                        <router-link :to="'/testimony-library/edit/' + data.id">
                            <button type="button" class="btn btn-rounded btn-warning waves-effect waves-light" title="Edit">
                                <i class="fa fa-edit"></i>
                            </button>
                        </router-link>
                        <button type="button" class="btn btn-rounded btn-danger waves-effect waves-light" title="Delete" @click="destroy(data)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </template> 
            </Table>
        </div>
    </div>
</template>

<script>
import Table from '@/components/Table.vue';
import Switches from 'vue-switches';
import { debounce } from "debounce";

export default {
	components: {
        Table,
        Switches,
	},
	data() {
		return {
			table: {
                title: 'Testimony Library',
                dataTable: {
                    header: ['#', 'Name', 'Condition Detail', 'Rating', 'Review', 'Action'],
                    columns: ['counter', 'name', 'conditionName', 'rating', 'review'],
                    lists: [],
                }
			},
            limit: 10,
            isLoading: false,
            // search & filter
            searchUserName: '',
            conditions: [],
            filterCondition: null,
		};
	},
    mounted() {
        this.getConditions();
        this.getList();

        this.$root.$on("paginate", (data) => {
            this.getList(data);
        });
        this.$root.$on("changeLimit", (data) => {
            this.limit = data;
            this.getList();
        });
    },
    methods: {
        handleSearchUserName: debounce(function() {
            this.getList();
        }, 500),
        getConditions() {
            this.axios.get('/dc-condition-page/list-all')
                .then(resp => {
                    this.conditions = resp.data.data;

                });
        },
        resetFilter() {
            this.searchUserName = '';
            this.filterCondition = null;
            this.getList();
        },
        getList(page = 1) {
            this.axios.get('/testimony-library', {
                params: {
                    page,
                    limit: this.limit,
                    sortBy: 'rating.DESC-nulllast,date.DESC,updatedAt.DESC',
                    name: this.searchUserName || undefined,
                    conditionId: this.filterCondition ? this.filterCondition.id : undefined,
                    type: 'before_after'
                }
            })
                .then((resp) => {
                    this.table.dataTable.lists = {
                        ...resp.data.data,
                        rows: resp.data.data.rows.map(item => ({
                            ...item,
                            conditionName: item.condition.name,
                        })),
                    };
                });
        },
        toggleVisibility(data) {
            this.axios.put('/testimony-library/visibility', {
                id: data.id,
                isVisible: data.isVisible,
            });
        },
        destroy(data) {
            this.$swal.fire({
                title: 'Are you sure want to delete this testimony?',
                text: data.name,
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'No',
                confirmButtonColor: '#0036A0',
                confirmButtonText: 'Yes',
            }).then((result) => {
                if (result.value) {
                    this.axios.delete(`/testimony-library/${data.id}`)
                        .then((resp) => {
                            this.$swal.fire({
                                title: 'Deleted!',
                                text: resp.message,
                                icon: 'success',
                                confirmButtonColor: '#0036A0',
                                confirmButtonText: 'OK'
                            });
                            this.getList();
                        })
                        .catch(() => {
                            this.$notify({
                                type: 'error',
                                title: 'Error!',
                                text: 'Failed to delete',
                            });
                        });
                }
            });
        },
    },
}
</script>